// NOTE: Changing these will require a migration of the database to update the constraints.
export enum MatchOutcomeEnum {
  WIN = 1,
  TIE = 0,
  LOSS = -1
}
